import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/lang-select-checked-dark.svg'
import _imports_1 from '@/assets/images/lang-select-checked.svg'
import _imports_2 from '@/assets/images/lang-select-unchecked-dark.svg'
import _imports_3 from '@/assets/images/lang-select-unchecked.svg'


const _hoisted_1 = _imports_0
const _hoisted_2 = _imports_2
const _hoisted_3 = { class: "language-selector" }
const _hoisted_4 = { class: "language-selector__title" }
const _hoisted_5 = { class: "language-selector__items" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "language-selector__status"
}
const _hoisted_8 = {
  key: 1,
  class: "language-selector__status"
}
const _hoisted_9 = { class: "language-selector__flag-and-lang" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "language-selector__language" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_3, [
    _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("common.lang.langSelection", "en")), 1),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.languages, (lang, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: index,
          class: "language-selector__item",
          href: "#",
          onClick: _withModifiers(($event: any) => ($setup.changeLang(lang)), ["prevent"])
        }, [
          ($setup.selected === lang)
            ? (_openBlock(), _createElementBlock("picture", _hoisted_7, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("source", {
                  srcset: _hoisted_1,
                  media: "(prefers-color-scheme: dark)"
                }, null, -1),
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: ""
                }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("picture", _hoisted_8, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("source", {
                  srcset: _hoisted_2,
                  media: "(prefers-color-scheme: dark)"
                }, null, -1),
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: ""
                }, null, -1)
              ]))])),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              class: "language-selector__flag",
              src: `${$setup.config.imagesPath}/flag-${lang}.svg`,
              alt: ""
            }, null, 8, _hoisted_10),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("common.lang." + lang)), 1)
          ])
        ], 8, _hoisted_6))
      }), 128))
    ])
  ]))
}